<template>
    <div class="row">
        <div class="col-md-4">
            Zip codes not allowed:<br/>
            <textarea class="excluded-zip-codes form-control" placeholder="One per zip code per line..." v-model="rule.settings.excluded_zip_codes"></textarea>
        </div>
        <div class="col-md-6">
            Message to customer:
            <textarea class="zip-code-message form-control" placeholder="Purchases from your area..." v-model="rule.settings.message"></textarea>	
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            rule: Object
        }
    }
</script>